angular.
module("dx.webapp.routes").
controller("DxLiveViewRouteController", function LiveViewRouteController(
	$filter,
	$interval,
	$location,
	$rootScope,
	$routeParams,
	$scope,
	$timeout,

	DX_EXAMS_STEPS,
	DX_URLS,
	DX_SPELLCHECKSETTING,
	DX_STUDENT_SORT_PREDICATE,
	dxExam,
	dxExamsNavigator,
	dxRavenInterceptor,
	dxSorting,
	Exam,
	ExamRepository,
	examStatus,
	settingFlags,
	RoleTypeEnum,
	dxSession,
	DX_INVIGILATOR_SETTINGS,
	DX_INVIGILATOR_LOCATION_CONSTANTS,
	dxApi,
	NodeRepository,
	dxTime,

	dxDialog,
	dxLocalize,
	DX_KEY_CODES
) {
	"use strict";

	var self = this;
	var statusTime = new Date().getTime();
	var monitorStartedAt = null;
	var studentStatuses = {};
	var heartbeatHistory = {};
	var progressRequestId = 0;
	var appliedProgressRequestId = 0;
	var settingsRevision = 0;
	var destroyed = false;
	var announcedCounts = "";
	var statusLabels = {
		working: "LiveView.Status.InProgress",
		workingAgain: "LiveView.Status.Resumed",
		check: "LiveView.Status.CheckStudent",
		offline: "LiveView.Status.WorkingOffline",
		reopened: "TurnedIn",
		done: "TurnedIn",
		idle: "NotStarted",
		absent: "Absent",
		traditional: "PenAndPaper",
	};

	self.dxExamsNavigator = dxExamsNavigator;
	self.DX_EXAMS_STEPS = DX_EXAMS_STEPS;

	self.dxSession = dxSession;
	self.RoleTypeEnum = RoleTypeEnum;
	self.DX_INVIGILATOR_SETTINGS = DX_INVIGILATOR_SETTINGS;
	self.DX_INVIGILATOR_LOCATION_CONSTANTS = DX_INVIGILATOR_LOCATION_CONSTANTS;

	self.reqs = {
		exam: false,
		progress: false,
		node: false,
	};

	self.studentProgress = [];
	self.questionCount = 0;
	self.DX_SPELLCHECKSETTING = DX_SPELLCHECKSETTING;
	self.unlockAllToggle = true;
	self.focusedRow = 0;
	self.DX_STUDENT_SORT_PREDICATE = DX_STUDENT_SORT_PREDICATE;

	// TODO: These needs to be updated to the correct url.
	self.lockExamsHelpUrl = dxLocalize.getLanguage() === "sv" ?
		"https://support.digiexam.se/hc/sv/articles/360022992293" :
		"https://support.digiexam.se/hc/en-us/articles/360022992293";

	self.studentFilter = {
		name: "",
		status: null,
	};

	self.orderStudentsBy = {
		predicate: DX_STUDENT_SORT_PREDICATE.FIRST_NAME,
		reverse: false,
	};

	self.filteredProgress = [];
	self.Urls = DX_URLS;
	self.dxApi = dxApi;
	self.studentSummary = {
		workingCount: 0,
		checkCount: 0,
		waitingCount: 0,
		reopenedCount: 0,
		offlineCount: 0,
		doneCount: 0,
		// Earlier receipts remain history; only doneCount represents current completion.
		receivedCount: 0,
		traditionalCount: 0,
		absentCount: 0,
	};

	self.settingsPending = {};
	self.participationSelection = {};
	self.participationOptions = [
		{value: "idle", label: "NotStarted"},
		{value: "offline", label: "LiveView.Status.WorkingOffline"},
		{value: "traditional", label: "PenAndPaper"},
		{value: "absent", label: "Absent"},
	];
	self.settingsBusy = false;
	self.settingsError = false;
	self.refreshing = false;
	self.progressLoadFailed = false;
	self.studentOfflineFileLabel = dxLocalize.get("LiveView.Work.FileReceivedLabel");
	self.sortOptions = [
		{value: DX_STUDENT_SORT_PREDICATE.FIRST_NAME, label: "FirstName"},
		{value: DX_STUDENT_SORT_PREDICATE.LAST_NAME, label: "LastName"},
		{value: DX_STUDENT_SORT_PREDICATE.EMAIL, label: "Email"},
		{value: DX_STUDENT_SORT_PREDICATE.STUDENT_CODE, label: "StudentCode"},
	];
	var studentSortPredicates = self.sortOptions.slice();
	var sortingStudentCodesDisabled = null;
	self.studentSortOptions = [];
	self.studentSortSelection = DX_STUDENT_SORT_PREDICATE.FIRST_NAME + ":asc";
	self.statusFilterOptions = [
		{value: null, label: "All"},
		{value: "working", label: "LiveView.Status.InProgress"},
		{value: "check", label: "LiveView.Summary.Check"},
		{value: "done", label: "TurnedIn"},
		{value: "received", label: "LiveView.Filters.WithRecordedHandIn"},
		{value: "waiting", label: "LiveView.Summary.Waiting"},
		{value: "offline", label: "LiveView.Status.WorkingOffline"},
		{value: "traditional", label: "PenAndPaper"},
		{value: "absent", label: "Absent"},
	];

	self.isPrintSubviewShown = false;

	NodeRepository.load(dxSession.getRole().organizationId).then(onNodeLoadSuccess);

	// Load exam and initialize stuff
	var examId = $routeParams.id != null ? parseInt($routeParams.id, 10) : 0; // eslint-disable-line eqeqeq, no-eq-null, no-negated-condition

	function onNodeLoadSuccess(node) {
		self.node = node;
		self.reqs.node = true;
	}

	function synchronizeSortSelection() {
		var conf = self.orderStudentsBy;
		var selection = conf.predicate + (conf.reverse ? ":desc" : ":asc");
		var allowed = self.studentSortOptions.some(function matchesSelection(option) {
			return option.value === selection;
		});
		if (!allowed) {
			conf.predicate = DX_STUDENT_SORT_PREDICATE.FIRST_NAME;
			conf.reverse = false;
			selection = conf.predicate + ":asc";
		}
		self.studentSortSelection = selection;
	}

	function updateStudentSortOptions(disabledStudentCodes) {
		var disabled = !!disabledStudentCodes;
		if (sortingStudentCodesDisabled === disabled) {
			return;
		}
		sortingStudentCodesDisabled = disabled;
		self.sortOptions = studentSortPredicates.filter(function allowedPredicate(option) {
			return !disabled || option.value !== DX_STUDENT_SORT_PREDICATE.STUDENT_CODE;
		});
		self.studentSortOptions = [];
		self.sortOptions.forEach(function addDirections(option) {
			[false, true].forEach(function addDirection(reverse) {
				self.studentSortOptions.push({
					value: option.value + (reverse ? ":desc" : ":asc"),
					predicate: option.value,
					reverse: reverse,
					label: dxLocalize.get(option.label) + " (" + dxLocalize.get(reverse ? "LiveView.Sort.Descending" : "LiveView.Sort.Ascending") + ")",
				});
			});
		});
		self.sortStudents();
	}

	self.setStudentsOrder = function setStudentsOrder(predicate) {
		var conf = self.orderStudentsBy;
		if (!self.sortOptions.some(function matchesPredicate(option) {
			return option.value === predicate;
		})) {
			conf.predicate = DX_STUDENT_SORT_PREDICATE.FIRST_NAME;
			conf.reverse = false;
			self.sortStudents();
			return;
		}
		if (conf.predicate === predicate) {
			conf.reverse = !conf.reverse;
			self.studentProgress.reverse();
		} else {
			conf.predicate = predicate;
			conf.reverse = false;
			self.studentProgress = dxSorting.studentSort(self.studentProgress, conf);
		}
		synchronizeSortSelection();
	};
	self.sortStudents = function sortStudents() {
		synchronizeSortSelection();
		self.studentProgress = dxSorting.studentSort(self.studentProgress, self.orderStudentsBy);
	};
	self.reverseStudentsOrder = function reverseStudentsOrder() {
		self.orderStudentsBy.reverse = !self.orderStudentsBy.reverse;
		self.studentProgress.reverse();
		synchronizeSortSelection();
	};
	self.applyStudentSort = function applyStudentSort() {
		var selected = self.studentSortOptions.filter(function matchesSelection(option) {
			return option.value === self.studentSortSelection;
		})[0] || self.studentSortOptions[0];
		self.orderStudentsBy.predicate = selected.predicate;
		self.orderStudentsBy.reverse = selected.reverse;
		self.sortStudents();
	};
	self.sortDirection = function sortDirection(predicate) {
		if (self.orderStudentsBy.predicate !== predicate) {
			return "none";
		}
		return self.orderStudentsBy.reverse ? "descending" : "ascending";
	};
	self.studentSortDirection = function studentSortDirection(column) {
		var predicate = self.orderStudentsBy.predicate;
		var isStudentSort = self.sortOptions.some(function matchesPredicate(option) {
			return option.value === predicate;
		});
		if (column === "student" && isStudentSort) {
			return self.orderStudentsBy.reverse ? "descending" : "ascending";
		}
		return null;
	};
	updateStudentSortOptions(false);
	$scope.$watch("vm.node.disabledStudentCodes", updateStudentSortOptions);

	function updateSummary() {
		var now = new Date().getTime();
		var lastResponse = self.lastUpdatedProgressTime ? self.lastUpdatedProgressTime.getTime() : monitorStartedAt;
		self.monitorUpdatesDelayed = lastResponse !== null && now - lastResponse >= 60000;
		// Freeze the entire overview, including filter membership, when its source is stale.
		if (self.monitorUpdatesDelayed && self.reqs.progress) {
			return;
		}
		statusTime = now;
		rebuildStudentStatuses();
	}

	function rebuildStudentStatuses() {
		studentStatuses = {};
		self.participationSelection = {};
		angular.forEach(self.studentSummary, function resetCount(value, key) {
			self.studentSummary[key] = 0;
		});

		for (var i = 0; i < self.studentProgress.length; i++) {
			var progress = self.studentProgress[i];
			var status = classifyStudent(progress);
			studentStatuses[progress.id] = status;
			self.participationSelection[progress.id] = status.kind;
			self.studentSummary[status.group + "Count"]++;
			if (status.hasHandInReceipt) {
				self.studentSummary.receivedCount++;
			}
			if (status.kind === "reopened") {
				self.studentSummary.reopenedCount++;
			}
			if (status.kind === "offline") {
				self.studentSummary.offlineCount++;
			}
		}
		var summary = self.studentSummary;
		var counts = [summary.checkCount, summary.workingCount, summary.doneCount, self.digitalStudentCount(), summary.waitingCount];
		if (self.reqs.progress && counts.join(",") !== announcedCounts) {
			announcedCounts = counts.join(",");
			self.overviewAnnouncement = formatText("LiveView.Summary.Announcement", counts);
		}
	}

	$scope.$watch("vm.studentProgress", updateSummary, true);
	$scope.$watchCollection("vm.filteredProgress", updateUnlockAllButton);
	self.timerText = "";
	self.lastUpdatedProgressTime = null;
	self.monitorUpdatesDelayed = false;
	self.timerDescription = "";
	self.forbidden = false;

	self.updateTimerText = function updateTimerText() {
		self.timerText = dxTime.elapsed(self.exam.start);
		self.timerDescription = dxLocalize.get("Elapsed");
		updateSummary();
	};

	self.updateLiveView = function updateLiveView() {
		if (destroyed) {
			return null;
		}
		var progressPromise = updateProgress();

		if (self.exam.examStatus === examStatus.PLANNED) {
			ExamRepository.load(examId).then(function reloadExam(loadedExam) {
				self.exam = loadedExam;
			});
		}

		if (dxSession.getRole().roleType === RoleTypeEnum.INVIGILATOR) {
			getInvigilatorSettings();
		}
		return progressPromise;
	};

	function updateProgress() {
		var handledErrorCodes = [403, 404];
		if (monitorStartedAt === null) {
			monitorStartedAt = new Date().getTime();
		}
		var requestId = ++progressRequestId;
		var revision = settingsRevision;
		self.refreshing = true;

		return dxApi.v1.exams.progress(self.exam.id, handledErrorCodes).then(function success(response) {
			if (destroyed || revision !== settingsRevision || requestId < appliedProgressRequestId) {
				return;
			}
			if (!response.data || !angular.isArray(response.data.studentsProgress)) {
				self.progressLoadFailed = true;
				return;
			}
			appliedProgressRequestId = requestId;
			self.progressLoadFailed = false;
			self.reqs.progress = true;
			self.lastUpdatedProgressTime = new Date();
			self.questionCount = response.data.questionCount;
			if (response.data.studentsProgress) {
				rememberHeartbeats(response.data.studentsProgress);
				self.copyStudentProgress(response.data.studentsProgress);
				handleRedactedPiiStudents();

				self.studentProgress = dxSorting.studentSort(self.studentProgress, self.orderStudentsBy);

				updateUnlockAllButton();
			}
			updateSummary();
		}, function failed(response) {
			if (destroyed || revision !== settingsRevision || requestId < appliedProgressRequestId) {
				return;
			}
			self.progressLoadFailed = true;
			if (handledErrorCodes.indexOf(response.status) > -1) {
				if (self.dxSession.getRole().roleType === self.RoleTypeEnum.INVIGILATOR) {
					$location.url(DX_URLS.get("overview"));
				} else {
					if (response.status === 403) {
						self.forbidden = true;
					}
					dxRavenInterceptor.logRejection(response);
				}
			}
		}).finally(function complete() {
			if (!destroyed && requestId === progressRequestId) {
				self.refreshing = false;
			}
		});
	}
	self.updateProgress = self.updateLiveView;

	function handleRedactedPiiStudents() {
		self.studentProgress.forEach(function foreachStudentProgress(student) {
			if (student.redactedPii) {
				student.firstName = dxLocalize.get("RedactedPii.StudentName");
				student.lastName = "";
				student.studentCode = "";
				student.email = "";
			}
		});
	}

	function updateUnlockAllButton() {
		self.unlockAllToggle = self.studentProgress.some(function isLocked(progress) {
			return !progress.isOpen;
		});
	}

	$scope.$on("$destroy", function destroy() {
		destroyed = true;
		heartbeatHistory = {};
		$interval.cancel(self.updateProgressInterval);
		$interval.cancel(self.updateTimerInterval);
	});

	// Copies a student progress array to the scope property by property.
	// This to prevent redraw of the full ng-repeat
	self.copyStudentProgress = function copyStudentProgress(newProgress) {
		var receivedIds = {};
		for (var j = 0; j < newProgress.length; j++) {
			var n = newProgress[j];
			receivedIds[n.id] = true;
			var found = false;
			for (var i = 0; i < self.studentProgress.length; i++) {
				var o = self.studentProgress[i];
				if (n.id === o.id) {
					// Copy property by property to prevent full rerender of the ng-repeat
					for (var key in n) {
						if (n.hasOwnProperty(key)) {
							o[key] = n[key];
						}
					}
					o.lastConnected = n.lastConnected;
					o.lastUpdate = n.lastUpdate;
					o.started = n.started;
					o.stopped = n.stopped;
					o.lastOfflineUploadTime = n.lastOfflineUploadTime;
					found = true;
					break;
				}
			}

			if (!found) {
				self.studentProgress.push(n);
			}
		}
		for (var index = self.studentProgress.length - 1; index >= 0; index--) {
			if (!receivedIds[self.studentProgress[index].id]) {
				self.studentProgress.splice(index, 1);
			}
		}
	};

	self.digitalStudentCount = function digitalStudentCount() {
		var summary = self.studentSummary;
		return summary.workingCount + summary.checkCount + summary.waitingCount + summary.doneCount;
	};

	// Include completed and unresponsive students in participation totals.
	self.hasOpenedCount = function hasOpenedCount() {
		return self.digitalStudentCount() - self.studentSummary.waitingCount;
	};

	self.hasFinishedCount = function hasFinishedCount() {
		return self.studentSummary.doneCount;
	};

	self.openOrCloseAll = function openOrCloseAll() {
		if (self.settingsBusy) {
			return;
		}
		var settingsToUpdate = [];

		for (var i = 0; i < self.studentProgress.length; i++) {
			var progress = self.studentProgress[i];

			if (progress.isOpen !== self.unlockAllToggle) {
				settingsToUpdate.push({
					studentId: progress.id,
					open: self.unlockAllToggle,
				});
			}
		}

		function dialogConfirm() {
			dxDialog.closeMostRecent();
			updateStudentSettings(settingsToUpdate);
		}

		if (settingsToUpdate.length) {
			dxDialog.confirm({
				title: dxLocalize.get(self.unlockAllToggle ? "LiveView.UnlockAll" : "LiveView.LockAll"),
				body: dxLocalize.get(self.unlockAllToggle ? "LiveView.UnlockAll.Question" : "LiveView.LockAll.Question"),
				acceptText: dxLocalize.get("Yes"),
				acceptCallback: dialogConfirm,
				rejectText: dxLocalize.get("No"),
			});
		}
	};

	self.openOrCloseExam = function openOrCloseExam(progress) {
		if (self.settingsPending[progress.id]) {
			return;
		}
		var open = !progress.isOpen;
		function dialogConfirm() {
			dxDialog.closeMostRecent();
			updateStudentSettings([{studentId: progress.id, open: open}]);
		}

		dxDialog.confirm({
			title: dxLocalize.get(progress.isOpen ? "LiveView.LockExam" : "LiveView.UnlockExam"),
			body: dxLocalize.get(progress.isOpen ? "LiveView.LockExam.Question" : "LiveView.UnlockExam.Question"),
			acceptText: dxLocalize.get("Yes"),
			acceptCallback: dialogConfirm,
			rejectText: dxLocalize.get("No"),
		});
	};

	function updateStudentSettings(settingsToUpdate) {
		self.settingsError = false;
		settingsToUpdate.forEach(function markPending(settings) {
			self.settingsPending[settings.studentId] = true;
		});
		self.settingsBusy = true;
		return dxApi.v1.exams.settings.put(self.exam.id, settingsToUpdate).then(function onResolve() {
			if (destroyed) {
				return;
			}
			settingsRevision++;
			for (var i = 0; i < settingsToUpdate.length; i++) {
				for (var j = 0; j < self.studentProgress.length; j++) {
					var updatedSettings = settingsToUpdate[i];
					var studentProgress = self.studentProgress[j];

					if (updatedSettings.studentId === studentProgress.id) {
						studentProgress.isOpen = updatedSettings.open;
						break;
					}
				}
			}
			rebuildStudentStatuses();
			updateUnlockAllButton();
			updateProgress();
		}, function onFail(response) {
			if (destroyed) {
				return;
			}
			self.settingsError = true;
			if (response.status === 403 && self.dxSession.getRole().roleType === self.RoleTypeEnum.INVIGILATOR) {
				$location.url(DX_URLS.get("overview"));
			}
		}).finally(function completeSettingsChange() {
			settingsToUpdate.forEach(function clearPending(settings) {
				delete self.settingsPending[settings.studentId];
			});
			self.settingsBusy = Object.keys(self.settingsPending).length > 0;
		});
	}

	self.startExam = function startExam() {
		dxDialog.closeMostRecent();
		self.exam.startExam().then(function success() {
			$location.url(DX_URLS.get("exams") + dxExamsNavigator(DX_EXAMS_STEPS.ongoing, self.exam.id));
		});
	};

	self.openEndExamDialog = function openEndExamDialog() {
		var scope = $rootScope.$new();
		scope.stopExam = self.stopExam;
		scope.studentSummary = self.studentSummary;
		scope.liveView = self;
		scope.noStudentHasStarted = self.noStudentHasStarted;
		scope.isGroupExam = self.isGroupExam;

		scope.closeEndExamDialog = function closeEndExamDialog() {
			dxDialog.closeMostRecent();
		};

		dxDialog.show({
			templateUrl: "tmpl/exams/end-exam.html",
			$scope: scope,
		});
	};


	self.goToGrading = function goToGrading() {
		$location.path(DX_URLS.get("examGrading", {id: self.exam.id}));
		var scope = $rootScope.$new();

		dxDialog.show({
			templateUrl: "/partials/popups/monitor-exam-info.html",
			$scope: scope,
		});
	};

	self.openConfirmStartDialog = function openConfirmStartDialog() {
		dxDialog.confirm({
			title: dxLocalize.get("StartExam"),
			body: dxLocalize.get("DoYouWantToStartTheExam", self.exam.title),
			acceptText: dxLocalize.get("YesStartExam"),
			rejectText: dxLocalize.get("Cancel"),
			acceptCallback: self.startExam,
		});
	};

	self.stopExam = function stopExam() {
		dxDialog.closeMostRecent();

		var promise = self.exam.stopExam();

		return promise.then(function success(response) {
			if (response.exam) {
				var ex = new Exam(response.exam);
				ExamRepository.cache(ex);

				var queryString = "";
				switch (ex.examStatus) {
					case examStatus.NOT_STARTED:
					case examStatus.PLANNED:
						queryString = dxExamsNavigator(DX_EXAMS_STEPS.scheduled, self.exam.id);
						break;
					case examStatus.GRADED:
						queryString = dxExamsNavigator(DX_EXAMS_STEPS.graded, self.exam.id);
						break;
					default:
						queryString = dxExamsNavigator(DX_EXAMS_STEPS.ungraded, self.exam.id);
				}

				$location.url(DX_URLS.get("exams") + queryString);
			} else {
				// delete from ExamRepository
				for (var i = 0; i < ExamRepository.exams.length; i++) {
					var e = ExamRepository.exams[i];

					if (e.id === self.exam.id) {
						ExamRepository.exams.splice(i, 1);
						break;
					}
				}

				if (self.dxSession.getRole().roleType === self.RoleTypeEnum.INVIGILATOR) {
					$location.url(DX_URLS.get("overview"));
				} else {
					$location.url(DX_URLS.get("exams"));
				}
			}
		});
	};

	// Some kind of safe array length function?
	self.length = function length(arr) {
		if (arr === null || typeof arr === "undefined") {
			return 0;
		}

		return arr.length;
	};

	// Changes the active tab on the view
	self.activeTab = "students";

	self.showTab = function showTab(tab) { // eslint-disable-line consistent-return
		if (self.activeTab === tab) {
			return false;
		}

		self.activeTab = tab;
	};

	// Shows the upload offline file dialog.
	self.uploadOfflineFile = function uploadOfflineFile() {
		var scope = $rootScope.$new();
		scope.examId = self.exam.id;
		scope.node = self.node;
		scope.onClose = updateProgress;

		dxDialog.show({
			templateUrl: "partials/popups/upload-offline-answer-file.html",
			$scope: scope,
		});
	};

	self.isPlanned = function isPlanned() {
		return self.exam && self.exam.examStatus === examStatus.PLANNED;
	};

	self.isActive = function isActive() {
		return self.exam && self.exam.examStatus === examStatus.ACTIVE;
	};

	self.hasEnded = function hasEnded() {
		return self.exam && (self.exam.examStatus >= examStatus.NOT_GRADED);
	};

	// Sets a flag on the exam
	self.setFlag = function setFlag(progress, newFlag) {
		if (self.settingsPending[progress.id]) {
			return null;
		}
		self.settingsPending[progress.id] = true;
		self.settingsBusy = true;
		self.settingsError = false;
		return dxExam.setFlags(progress.id, self.exam.id, newFlag).then(function success() {
			if (destroyed) {
				return;
			}
			settingsRevision++;
			progress.flags = newFlag;
			progress.isOpen = newFlag === settingFlags.NONE;
			rebuildStudentStatuses();
			updateProgress();
		}, function failed() {
			if (!destroyed) {
				self.settingsError = true;
			}
		}).finally(function completeFlagChange() {
			delete self.settingsPending[progress.id];
			self.settingsBusy = Object.keys(self.settingsPending).length > 0;
		});
	};

	// Clear exams flags
	self.markAsNotStarted = function markAsNotStarted(progress) {
		return self.setFlag(progress, settingFlags.NONE);
	};

	// Mark the exam as it was started offline.
	self.markAsOffline = function markAsOffline(progress) {
		return self.setFlag(progress, settingFlags.OFFLINE_START);
	};

	// Mark the exam as traditional, written with pen and paper
	self.markAsTraditional = function markAsTraditional(progress) {
		return self.setFlag(progress, settingFlags.TRADITIONAL_EXAM);
	};

	// Mark the exam as traditional, written with pen and paper
	self.markAsAbsent = function markAsAbsent(progress) {
		return self.setFlag(progress, settingFlags.STUDENT_ABSENT);
	};

	self.changeParticipation = function changeParticipation(progress) {
		var selected = self.participationSelection[progress.id];
		var confirmed = getStudentStatus(progress).kind;
		self.participationSelection[progress.id] = confirmed;
		if (self.settingsPending[progress.id] || !self.canMarkStudent(progress) || selected === confirmed) {
			return null;
		}
		switch (selected) {
			case "idle":
				return self.markAsNotStarted(progress);
			case "offline":
				return self.markAsOffline(progress);
			case "traditional":
				return self.markAsTraditional(progress);
			case "absent":
				return self.markAsAbsent(progress);
			default:
				return null;
		}
	};

	function formatText(key, values) {
		return dxLocalize.get(key).replace(/\{(\d+)\}/g, function replaceValue(match, index) {
			var value = values[index];
			return value === null || typeof value === "undefined" ? match : value;
		});
	}

	function getDateTime(value) {
		if (value === null || typeof value === "undefined" || value === "" || typeof value === "boolean") {
			return null;
		}
		var date = new Date(value);
		return isNaN(date.getTime()) || date.getUTCFullYear() < 2 ? null : date.getTime();
	}

	function hasStarted(progress) {
		return progress.isStarted || getDateTime(progress.started) !== null || getDateTime(progress.stopped) !== null;
	}

	function currentSignal(value, started, stopped) {
		var time = getDateTime(value);
		// The previous hand-in is the only re-entry boundary supplied by this API.
		return time === null || (stopped !== null && time <= stopped) || (started !== null && time < started) ? null : time;
	}

	function rememberHeartbeats(progresses) {
		var currentHistory = {};
		progresses.forEach(function rememberHeartbeat(progress) {
			if (progress.isDone || !hasStarted(progress)) {
				return;
			}
			var started = getDateTime(progress.started);
			var stopped = getDateTime(progress.stopped);
			var heartbeat = latestHeartbeat(progress, started, stopped);
			if (heartbeat !== null) {
				currentHistory[progress.id] = {started: started, stopped: stopped, heartbeat: heartbeat};
			}
		});
		// Rebuilding also clears completed/reset attempts and students removed from the snapshot.
		heartbeatHistory = currentHistory;
	}

	function latestHeartbeat(progress, started, stopped) {
		var heartbeat = currentSignal(progress.lastConnected, started, stopped);
		var previous = heartbeatHistory[progress.id];
		// A missing report must not extend a known reporting attempt's timeout to five minutes.
		if (!progress.isDone && hasStarted(progress) && previous && previous.started === started && previous.stopped === stopped) {
			var retained = currentSignal(previous.heartbeat, started, stopped);
			if (retained !== null && (heartbeat === null || retained > heartbeat)) {
				heartbeat = retained;
			}
		}
		return heartbeat;
	}

	function classifyStudent(progress) {
		var started = getDateTime(progress.started);
		var stopped = getDateTime(progress.stopped);
		var heartbeat = latestHeartbeat(progress, started, stopped);
		var answer = currentSignal(progress.lastUpdate, started, stopped);
		var start = currentSignal(progress.started, started, stopped);
		var activity = heartbeat;
		if (answer !== null && (activity === null || answer > activity)) {
			activity = answer;
		}
		if (heartbeat === null && start !== null && (activity === null || start > activity)) {
			activity = start;
		}

		function result(kind, group, reason) {
			return {
				kind: kind,
				group: group,
				reason: reason,
				activity: activity,
				heartbeat: heartbeat,
				answer: answer,
				start: start,
				hasHandInReceipt: group !== "absent" && group !== "traditional" && (progress.isDone || stopped !== null),
			};
		}

		if (progress.isDone) {
			return progress.isOpen ? result("reopened", "done", "LiveView.Reason.UnlockedForReturn") : result("done", "done", null);
		}
		if (hasStarted(progress)) {
			if (activity === null) {
				return result("check", "check", stopped === null ? "LiveView.Reason.NoCurrentUpdates" : "LiveView.Reason.NoUpdatesAfterReopening");
			}
			var threshold = heartbeat === null ? 300000 : 120000;
			if (statusTime - activity > threshold) {
				return result("check", "check", heartbeat === null ? "LiveView.Reason.NoRecentWork" : "LiveView.Reason.NoContactFor");
			}
			return result(stopped === null ? "working" : "workingAgain", "working", heartbeat === null ? "LiveView.Reason.LiveContactUnconfirmed" : "LiveView.Reason.LastContact");
		}
		if ((progress.flags & settingFlags.STUDENT_ABSENT) !== 0) {
			return result("absent", "absent", null);
		}
		if ((progress.flags & settingFlags.TRADITIONAL_EXAM) !== 0) {
			return result("traditional", "traditional", null);
		}
		if ((progress.flags & settingFlags.OFFLINE_START) !== 0 || getDateTime(progress.lastOfflineUploadTime) !== null) {
			return result("offline", "working", "LiveView.Reason.OfflineWork");
		}
		return result("idle", "waiting", null);
	}

	function getStudentStatus(progress) {
		return studentStatuses[progress.id] || classifyStudent(progress);
	}

	function durationText(time) {
		var minutes = Math.max(0, Math.floor((statusTime - time) / 60000));
		if (minutes < 60) {
			return minutes === 1 ? dxLocalize.get("LiveView.Time.Minute") : formatText("LiveView.Time.Minutes", [minutes]);
		}
		var hours = Math.floor(minutes / 60);
		if (hours < 24) {
			return hours === 1 ? dxLocalize.get("LiveView.Time.Hour") : formatText("LiveView.Time.Hours", [hours]);
		}
		var days = Math.floor(hours / 24);
		return days === 1 ? dxLocalize.get("LiveView.Time.Day") : formatText("LiveView.Time.Days", [days]);
	}

	function clockText(time) {
		var today = $filter("date")(statusTime, "yyyy-MM-dd");
		return $filter("date")(time, $filter("date")(time, "yyyy-MM-dd") === today ? "HH:mm" : "yyyy-MM-dd HH:mm");
	}

	function relativeText(time) {
		return statusTime - time < 60000 ? dxLocalize.get("LiveView.Time.JustNow") : formatText("LiveView.Time.Ago", [durationText(time)]);
	}

	function todayAgeText(time) {
		return $filter("date")(time, "yyyy-MM-dd") === $filter("date")(statusTime, "yyyy-MM-dd") ? relativeText(time) : "";
	}

	function timeText(time) {
		return relativeText(time) + " · " + clockText(time);
	}

	function handInTime(progress) {
		var stopped = getDateTime(progress.stopped);
		var offline = getDateTime(progress.lastOfflineUploadTime);
		return progress.isDone && offline !== null && (stopped === null || offline > stopped) ? offline : stopped;
	}

	function lastAnswerTime(progress) {
		var status = getStudentStatus(progress);
		if (status.group === "done") {
			return getDateTime(progress.lastUpdate);
		}
		if (["idle", "absent", "traditional"].indexOf(status.kind) !== -1) {
			return null;
		}
		return currentSignal(progress.lastUpdate, getDateTime(progress.started), getDateTime(progress.stopped));
	}

	self.studentStatusText = function studentStatusText(progress) {
		return dxLocalize.get(statusLabels[getStudentStatus(progress).kind]);
	};

	self.studentStatusReason = function studentStatusReason(progress) {
		var status = getStudentStatus(progress);
		if (!status.reason) {
			return "";
		}
		if (status.reason === "LiveView.Reason.LastContact") {
			return formatText(status.reason, [clockText(status.activity)]);
		}
		if (status.reason === "LiveView.Reason.NoContactFor") {
			return formatText(status.reason, [durationText(status.activity)]) + " · " + clockText(status.activity);
		}
		if (status.reason === "LiveView.Reason.NoRecentWork") {
			return formatText(status.reason, [timeText(status.activity)]);
		}
		return dxLocalize.get(status.reason);
	};

	self.studentStatusClass = function studentStatusClass(progress) {
		var status = getStudentStatus(progress);
		var color = "neutral";
		if (!self.monitorUpdatesDelayed) {
			if (status.group === "check") {
				color = "warning";
			} else if (status.group === "done") {
				color = "done";
			} else if (status.group === "working") {
				color = "progress";
			}
		}
		return "monitor-status-badge--" + color;
	};

	self.studentRowClass = function studentRowClass(progress) {
		if (self.monitorUpdatesDelayed) {
			return "monitor-row--last-known";
		}
		return getStudentStatus(progress).group === "check" ? "monitor-row--check" : "";
	};

	self.canMarkStudent = function canMarkStudent(progress) {
		return ["idle", "offline", "traditional", "absent"].indexOf(getStudentStatus(progress).kind) !== -1;
	};

	self.studentIdentity = function studentIdentity(progress) {
		return !self.node.disabledStudentCodes && progress.studentCode ? progress.studentCode : progress.email;
	};

	self.studentExtraEmail = function studentExtraEmail(progress) {
		return progress.email && progress.email !== self.studentIdentity(progress) ? progress.email : "";
	};

	self.studentCodeText = function studentCodeText(progress) {
		if (!self.node || self.node.disabledStudentCodes || progress.studentCode === null || typeof progress.studentCode === "undefined" || progress.studentCode === "") {
			return "";
		}
		return String(progress.studentCode);
	};

	self.studentWorkHeading = function studentWorkHeading(progress) {
		return self.studentHandInHeading(progress);
	};

	self.hasHandInReceipt = function hasHandInReceipt(progress) {
		return getStudentStatus(progress).hasHandInReceipt;
	};

	self.studentHandInText = function studentHandInText(progress) {
		var time = handInTime(progress);
		return self.hasHandInReceipt(progress) && time !== null ? clockText(time) : "";
	};

	self.studentHandInDetail = function studentHandInDetail(progress) {
		if (!self.hasHandInReceipt(progress)) {
			return "";
		}
		if (self.isResumedWork(progress)) {
			return dxLocalize.get("LiveView.Work.BeforeWorkResumed");
		}
		var time = handInTime(progress);
		return time === null ? dxLocalize.get("LiveView.Work.TimeUnavailable") : todayAgeText(time);
	};

	self.studentFirstStartedText = function studentFirstStartedText(progress) {
		var time = getDateTime(progress.started);
		return time === null ? "" : $filter("date")(time, "yyyy-MM-dd HH:mm");
	};

	self.studentLastAnswerText = function studentLastAnswerText(progress) {
		var status = getStudentStatus(progress);
		var time = lastAnswerTime(progress);
		if (time !== null) {
			return clockText(time);
		}
		if (status.group === "done" || ["idle", "absent", "traditional"].indexOf(status.kind) !== -1) {
			return "";
		}
		return dxLocalize.get(getDateTime(progress.stopped) === null ? "LiveView.Work.NoAnswers" : "LiveView.Work.NoNewerAnswers");
	};

	self.studentLastAnswerDetail = function studentLastAnswerDetail(progress) {
		var time = lastAnswerTime(progress);
		return time === null ? "" : todayAgeText(time);
	};

	self.studentLastAnswerHasTime = function studentLastAnswerHasTime(progress) {
		return lastAnswerTime(progress) !== null;
	};

	self.isResumedWork = function isResumedWork(progress) {
		return !progress.isDone && getDateTime(progress.stopped) !== null;
	};

	self.studentHandInHeading = function studentHandInHeading(progress) {
		var status = getStudentStatus(progress);
		if (status.hasHandInReceipt) {
			return handInTime(progress) === null ? dxLocalize.get("LiveView.Work.HandInReceived") : "";
		}
		if (["idle", "absent", "traditional"].indexOf(status.kind) !== -1) {
			return dxLocalize.get("LiveView.Work.NoHandIn");
		}
		if (self.studentOfflineFileText(progress)) {
			return dxLocalize.get("LiveView.Work.HandInUnconfirmed");
		}
		return dxLocalize.get("LiveView.Work.AwaitingHandIn");
	};

	self.previousHandInText = function previousHandInText(progress) {
		return self.isResumedWork(progress) ? dxLocalize.get("LiveView.Work.BeforeWorkResumed") : "";
	};

	self.studentAnswersText = function studentAnswersText(progress) {
		var status = getStudentStatus(progress);
		if (status.kind === "absent" || status.kind === "traditional") {
			return "";
		}
		if (status.group === "done") {
			return "";
		}
		if (status.answer !== null) {
			return formatText("LiveView.Work.AnswersReceived", [timeText(status.answer)]);
		}
		if (handInTime(progress) !== null) {
			return dxLocalize.get("LiveView.Work.NoNewerAnswers");
		}
		return status.group === "waiting" || status.kind === "offline" ? "" : dxLocalize.get("LiveView.Work.NoAnswers");
	};

	self.studentStartText = function studentStartText(progress) {
		var status = getStudentStatus(progress);
		return status.group !== "done" && status.start !== null && status.answer === null ? formatText("LiveView.Work.Started", [timeText(status.start)]) : "";
	};

	self.studentOfflineFileText = function studentOfflineFileText(progress) {
		var time = getDateTime(progress.lastOfflineUploadTime);
		var stopped = getDateTime(progress.stopped);
		return !progress.isDone && time !== null && (stopped === null || time > stopped) ? clockText(time) : "";
	};

	self.filterStudent = function filterStudent(progress) {
		var text = (self.studentFilter.text || "").toLowerCase();
		var identity = [progress.firstName, progress.lastName, progress.email];
		if (!self.node.disabledStudentCodes) {
			identity.push(progress.studentCode);
		}
		if (text && identity.join(" ").toLowerCase().indexOf(text) === -1) {
			return false;
		}
		var filter = self.studentFilter.status;
		var status = getStudentStatus(progress);
		if (filter === "received") {
			return status.hasHandInReceipt;
		}
		return filter === null || status.group === filter || status.kind === filter;
	};
	self.onTableRowKeyDown = function onTableRowKeyDown(event, id) {
		if (event.target !== event.currentTarget || (event.keyCode !== DX_KEY_CODES.enter && event.keyCode !== DX_KEY_CODES.space)) {
			return;
		}

		self.showStudent(id);
	};

	self.showStudent = function showStudent(id) {
		if (dxSession.getRole().roleType === RoleTypeEnum.INVIGILATOR) {
			return;
		}

		$location.path(self.Urls.get("student", {id: id}));
	};

	self.studentHover = function studentHover(hoverEvent, hover) {
		if (dxSession.getRole().roleType === RoleTypeEnum.INVIGILATOR) {
			return;
		}

		var studentInformationRow = hoverEvent.target.parentElement.getElementsByClassName("studentInformation");
		for (var i = 0; i < studentInformationRow.length; i++) {
			if (hover) {
				studentInformationRow[i].classList.add("studentHover");
			} else {
				studentInformationRow[i].classList.remove("studentHover");
			}
		}
	};

	self.studentFilterTextChanged = function studentFilterTextChanged() {
		$timeout(updateUnlockAllButton);
	};

	self.toggleStatusFilter = function toggleStatusFilter(filter) {
		if (self.studentFilter.status === filter) {
			self.studentFilter.status = null;
			return;
		}

		self.studentFilter.status = filter;

		$timeout(updateUnlockAllButton);
	};

	self.clearFilters = function clearFilters() {
		self.studentFilter.status = null;
		self.studentFilter.text = "";

		$timeout(updateUnlockAllButton);
	};

	self.noStudentHasStarted = function noStudentHasStarted() {
		return self.hasOpenedCount() === 0;
	};

	self.isGroupExam = function isGroupExam() {
		return self.exam.isGroupExam();
	};

	self.isSettingEnabled = function isSettingEnabled(setting) {
		if (self.dxSession.getRole().roleType === self.RoleTypeEnum.INVIGILATOR) {
			return (self.exam.invigilatorSettings & setting);
		}
		return true;
	};

	function getInvigilatorSettings() {
		dxApi.v1.exams.shares.data.get().then(function addInvigilatorSettings(response) {
			var shareData = response.data;
			var shareNotFound = true;
			for (var i = 0; i < shareData.length; i++) {
				if (shareData[i].objectId === self.exam.id) {
					self.exam.invigilatorSettings = shareData[i].data[0];
					shareNotFound = false;
					break;
				}
			}

			if (shareNotFound) {
				self.exam.invigilatorSettings = DX_INVIGILATOR_SETTINGS.NONE;
			}
		}, function onGetSettingsError() {
			self.exam.invigilatorSettings = DX_INVIGILATOR_SETTINGS.NONE;
		});
	}

	if (examId !== 0) {
		ExamRepository.load(examId).then(function success(loadedExam) {
			if (destroyed) {
				return;
			}
			self.reqs.exam = true;
			self.exam = loadedExam;
			self.examStartMonth = $filter("date")(self.exam.start, "M");
			self.examStopMonth = $filter("date")(self.exam.stop, "M");
			self.updateTimerText();
			self.updateTimerInterval = $interval(self.updateTimerText, 1000);
			self.updateLiveView();
			self.updateProgressInterval = $interval(self.updateLiveView, 20000);

			if (dxSession.getRole().roleType === RoleTypeEnum.INVIGILATOR) {
				getInvigilatorSettings();
			}

			/*
			** Watch the status so we can update the progress right away when the exam
			** is started instead of waiting for the interval to do it.
			** TODO: Fix so there is no race condition and remove the timeout.
			** We're using a timeout because the database might not have finished
			** writing the progress if we fetch it right away after starting an exam.
			*/

			function timeoutCallback() {
				$timeout(self.updateLiveView, 1000);
			}

			$scope.$watch("vm.exam.status", timeoutCallback, true);
		}, function failed() {
			self.forbidden = true;
		});
	}
});
